import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal', 'closeButton'];
  static values = {
    source: String,
  };

  initialize() {
    this.clickOutside = this.clickOutside.bind(this);
    this.handleEnterKey = this.handleEnterKey.bind(this);
  }

  connect() {
    if (!this.hasModalTarget) return;
    this.modalTarget.addEventListener('keydown', this.handleEnterKey);
    this.modalTarget.addEventListener('click', this.clickOutside);
  }

  disconnect() {
    if (!this.hasModalTarget) return;
    this.modalTarget.removeEventListener('keydown', this.handleEnterKey);
    this.modalTarget.removeEventListener('click', this.clickOutside);
  }

  show() {
    this.hasModalTarget && this.modalTarget.showModal();
  }

  hide() {
    this.hasModalTarget && this.modalTarget.close();

    // Ensure the dialog frame is reset when closed
    if (!this.hasSourceValue) return;
    document.getElementById('reflections-dialog-frame').src = this.sourceValue;
  }

  clickOutside(event) {
    if (!this.hasModalTarget) return;

    var rect = this.modalTarget.getBoundingClientRect();
    var isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX && event.clientX <= rect.left + rect.width);

    if (!isInDialog) {
      this.hide();
    }
  }

  handleEnterKey(event) {
    // Pressing Enter on a <dialog> element will close it,
    // so we need to prevent that if the Enter key is pressed
    // while the dialog is focused, but not on the close button.
    if (event.key === 'Enter' && (!this.hasCloseButtonTarget || event.target !== this.closeButtonTarget)) {
      setTimeout(() => {
        this.show();
      }, 200);
    }
  }
}
